module.exports = __webpack_public_path__ + "img/coffee.335c5ff1.png";